import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface TrainerUser {
  avatar: string | null
  email: string
  firstName: string
  isActive: boolean
  lastName: string
}

export interface TrainerServiceType {
  active?: boolean
  color?: string
  icon?: string
  id?: number
  name: string
}

export interface TrainerService {
  fee: number
  // Note: BE stores the fee type as 0/1 - 1 is a percentage of the service price, 0 is a flat rate
  percentage: number
  // Note: BE populates this as null when the training type no longer exists
  serviceId: TrainerServiceType | null
}

export interface Trainer {
  active: boolean
  apartment: string | null
  buildingIds: { id: number; name: string }[]
  // Note: BE sends every client with the building and user populated - only the count is used here
  clients: { id: number }[]
  createdAt: number
  gender: string | null
  id: number
  phone: number | null
  services: TrainerService[]
  street: string | null
  user: TrainerUser
  zipCode: string | null
}

export const USE_GET_TRAINERS_QUERY_KEY = 'useGetTrainers'

export const getTrainers = async (signal?: AbortSignal) => {
  const response = await authAPI.get<Trainer[]>('/trainer/all', { signal })
  return response.data
}

export const useGetTrainers = () => {
  return useQuery({
    queryFn: ({ signal }) => getTrainers(signal),
    queryKey: [USE_GET_TRAINERS_QUERY_KEY],
  })
}

export const useInvalidateTrainers = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: [USE_GET_TRAINERS_QUERY_KEY] })
}
